export function buildUrl(
  baseUrl: string,
  path: string,
  params?: Record<string, string | number | string[] | undefined>
): string {
  const url = `${baseUrl}${path.startsWith("/") ? "" : "/"}${path}`;

  if (!params || Object.keys(params).length === 0) return url;

  const searchParams = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined) continue;
    if (Array.isArray(value)) {
      searchParams.set(key, value.join(","));
    } else {
      searchParams.set(key, String(value));
    }
  }

  const qs = searchParams.toString();
  return qs ? `${url}?${qs}` : url;
}
